export const FEATURES = {
    AI_GENERATION: 'ai_generation',
    BILLING: 'billing',
    ENGAGEMENT: 'engagement',
    LEADS_CRM: 'leads_crm',
    POSTING: 'posting',
    ANALYTICS: 'analytics',
    WAITLIST_MODE: 'waitlist_mode',
};

// Features that support per-platform granularity (mirrors backend PLATFORM_FEATURES)
export const PLATFORM_FEATURES = ['posting', 'engagement', 'analytics'];

// All supported platforms (mirrors backend KNOWN_PLATFORMS and PLATFORM_CONFIG keys)
export const KNOWN_PLATFORMS = ['youtube', 'instagram', 'facebook', 'twitter', 'linkedin', 'reddit'];
